/* Cœura place lookup — the Location field in the engraving composer.
   The customer types; this offers the places that match and hands back the coordinates to engrave
   and the IANA timezone. The timezone is why a moon sign asks for a place at all: it is what turns
   "the 14th at 9pm" into an instant the Moon can be placed at.

   CoeuraPlaces.attach(input, { api, onPick, onClear }) -> { destroy }
   Data comes from GET <api>/api/places?q=. If that is unreachable the field simply finds nothing
   and every field it would have filled stays typeable, so nobody is ever blocked by it. */
(function () {
  'use strict';

  var WAIT = 180;                 // ms after the last keystroke before asking
  var MIN = 2;                    // characters before we ask at all
  var uid = 0;
  var cache = {};                 // q -> places, per page load

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* 34.4208 -> "34.4208° N" in the house format, and short enough for a 12-character line */
  function coord(v, axis) {
    var hemi = axis === 'lat' ? (v < 0 ? 'S' : 'N') : (v < 0 ? 'W' : 'E');
    return Math.abs(v).toFixed(4) + '° ' + hemi;
  }

  function attach(input, opts) {
    opts = opts || {};
    var api = (opts.api || '').replace(/\/$/, '');
    var id = 'cgp' + (++uid);
    var wrap = document.createElement('div');
    wrap.className = 'cg-place__wrap';
    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(input);
    var list = document.createElement('ul');
    list.className = 'cg-place__list';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    wrap.appendChild(list);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', id);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');

    var items = [], active = -1, timer = null, seq = 0, open = false;

    function close() {
      open = false; active = -1; list.hidden = true; items = [];
      list.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function draw(places) {
      items = places || [];
      if (!items.length) { close(); return; }
      list.innerHTML = items.map(function (p, i) {
        return '<li class="cg-place__opt" role="option" id="' + id + '-' + i + '" data-i="' + i +
          '"><span class="cg-place__name">' + esc(p.name) + '</span>' +
          '<span class="cg-place__where">' + esc([p.region, p.country].filter(Boolean).join(', ')) + '</span></li>';
      }).join('');
      list.hidden = false; open = true; active = -1;
      input.setAttribute('aria-expanded', 'true');
    }

    function highlight(n) {
      if (!items.length) return;
      active = (n + items.length) % items.length;
      list.querySelectorAll('.cg-place__opt').forEach(function (el, i) {
        el.classList.toggle('is-on', i === active);
        if (i === active && el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
      });
      input.setAttribute('aria-activedescendant', id + '-' + active);
    }

    function pick(i) {
      var p = items[i];
      if (!p) return;
      input.value = p.label;
      close();
      if (opts.onPick) {
        opts.onPick({
          name: p.name, region: p.region, country: p.country, label: p.label,
          lat: p.lat, lng: p.lng, tz: p.tz,
          latText: coord(p.lat, 'lat'), lngText: coord(p.lng, 'lng')
        });
      }
    }

    function ask() {
      var q = input.value.trim();
      if (q.length < MIN) { close(); return; }
      if (cache[q]) { draw(cache[q]); return; }
      if (!api) return;
      var mine = ++seq;
      fetch(api + '/api/places?q=' + encodeURIComponent(q), { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (mine !== seq) return;                       // a later keystroke already won
          var places = (d && d.places) || [];
          cache[q] = places;
          if (document.activeElement === input) draw(places);
        })
        .catch(function () { /* offline or blocked: the field stays typeable, nothing breaks */ });
    }

    function onInput() {
      if (opts.onClear) opts.onClear();                   // typing again invalidates the last pick
      clearTimeout(timer);
      timer = setTimeout(ask, WAIT);
    }
    function onKey(e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (open) highlight(active + 1); else ask(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (open) highlight(active - 1); }
      else if (e.key === 'Enter') { if (open && active >= 0) { e.preventDefault(); pick(active); } }
      else if (e.key === 'Escape') { if (open) { e.stopPropagation(); close(); } }
    }
    function onDown(e) {
      var li = e.target.closest ? e.target.closest('.cg-place__opt') : null;
      if (li) { e.preventDefault(); pick(+li.getAttribute('data-i')); }
    }
    function onBlur() { setTimeout(close, 120); }         // let a click on the list land first

    input.addEventListener('input', onInput);
    input.addEventListener('keydown', onKey);
    input.addEventListener('blur', onBlur);
    list.addEventListener('mousedown', onDown);

    return {
      destroy: function () {
        input.removeEventListener('input', onInput);
        input.removeEventListener('keydown', onKey);
        input.removeEventListener('blur', onBlur);
        list.removeEventListener('mousedown', onDown);
        close();
      }
    };
  }

  window.CoeuraPlaces = { attach: attach, coord: coord };
})();
